module.exports = function anonymous(it
/*``*/) {
var out='<div class="loading-message"> <p>'+(it)+'</p></div>';return out;
}


//////////////////
// WEBPACK FOOTER
// ./source/scripts/templates/loading.dot
// module id = 69
// module chunks = 0